import React, { useEffect, useRef, useState } from "react";
import { FaPlus, FaSearch } from "react-icons/fa";

import { defaultVariables } from "../../helpers/default-variables";
import "./add-variables.css";

const AddVariablesInText = (props) => {
	const [query, setQuery] = useState("");

	// Última seleção válida dentro de um campo contenteditable. Necessária porque
	// digitar na busca rouba a seleção; guardamos a do campo p/ restaurar no clique.
	const savedRange = useRef(null);

	useEffect(() => {
		const onSelectionChange = () => {
			const sel = window.getSelection();
			if (!sel || !sel.rangeCount) return;
			const range = sel.getRangeAt(0);
			const node = range.commonAncestorContainer;
			const el = node.nodeType === 3 ? node.parentElement : node;
			if (el && (el.closest(".inputTextArea") || el.closest(".inputText"))) {
				savedRange.current = range.cloneRange();
			}
		};
		document.addEventListener("selectionchange", onSelectionChange);
		return () =>
			document.removeEventListener("selectionchange", onSelectionChange);
	}, []);

	const restoreSavedSelection = () => {
		const range = savedRange.current;
		if (!range) return;
		const container = range.commonAncestorContainer;
		const el = container.nodeType === 3 ? container.parentElement : container;
		const editable =
			el?.closest?.(".inputTextArea") || el?.closest?.(".inputText");
		if (editable && editable.focus) editable.focus();
		const sel = window.getSelection();
		sel.removeAllRanges();
		sel.addRange(range);
	};

	const addVarContent = (event) => {
		// Nome da variável ANTES de qualquer mudança de foco/seleção.
		const variableToInsert = event.currentTarget.textContent.trim();

		// Devolve o cursor ao campo de texto (a busca pode ter roubado a seleção).
		restoreSavedSelection();

		var sel, range;

		const isDefaultVar = defaultVariables.includes(variableToInsert);

		const html = `<span contenteditable="false" class="variableInText ${
			isDefaultVar ? "defaultVar" : ""
		}">{{${variableToInsert}}}</span>`;
		if (window.getSelection) {
			sel = window.getSelection();
			if (sel.getRangeAt && sel.rangeCount) {
				range = sel.getRangeAt(0);

				const isValid =
					range?.commonAncestorContainer?.classList?.contains(
						"inputTextArea"
					) || range?.commonAncestorContainer?.classList?.contains("inputText");

				if (
					range.commonAncestorContainer.parentElement.closest(
						".inputTextArea"
					) ||
					range.commonAncestorContainer.parentElement.closest(".inputText") ||
					isValid
				) {
					range.deleteContents();
					var el = document.createElement("div");
					el.innerHTML = html;
					var frag = document.createDocumentFragment(),
						node,
						lastNode;
					while ((node = el.firstChild)) {
						lastNode = frag.appendChild(node);
					}

					range.insertNode(frag);
					if (lastNode) {
						range = range.cloneRange();
						range.setStartAfter(lastNode);
						range.collapse(true);
						sel.removeAllRanges();
						sel.addRange(range);
					}
				}
			}
		} else if (document.selection && document.selection.type !== "Control") {
			document.selection.createRange().pasteHTML(html);
		}

		document
			.querySelectorAll(".inputTextArea span:not(.variableInText)")
			.forEach((sp) => sp.remove());
	};

	const q = query.trim().toLowerCase();
	const filtered = (props.variables || []).filter((v) =>
		v.name.toLowerCase().includes(q)
	);

	return (
		<div className="content_variables">
			<div className="content_variables__label">
				Para adicionar variáveis nos campos de texto, selecione abaixo:
			</div>

			<div className="content_variables__search">
				<FaSearch />
				<input
					value={query}
					onChange={(e) => setQuery(e.target.value)}
					placeholder="Buscar variável"
				/>
			</div>

			<div className="content_variables__list">
				{filtered.map((varx) => (
					<button
						key={varx.name}
						type="button"
						className={`opt-variable-modal ${
							defaultVariables.includes(varx.name) ? "defaultVar" : ""
						}`}
						title={varx.name}
						onClick={addVarContent}
					>
						{varx.name}
					</button>
				))}
				{!filtered.length && (
					<span className="content_variables__empty">
						Nenhuma variável encontrada
					</span>
				)}
			</div>

			{props.showCreateVarButton && (
				<button className="create-variable" onClick={props.handleModalVariable}>
					Criar variável <FaPlus size={10} />
				</button>
			)}
		</div>
	);
};

export default AddVariablesInText;
